import { gql } from '@apollo/client';

export const NAS_CONFIG_STATUS = gql`
  query NasConfigStatus {
    nasConfigStatus {
      configured
      host
      basePath
      updatedAt
      updatedByName
    }
  }
`;

export const NAS_FILES_FOR_ADMIN = gql`
  query NasFilesForAdmin($path: String) {
    nasFilesForAdmin(path: $path) {
      name
      path
      type
      size
      lastModified
      mime
    }
  }
`;

export const NAS_MEDIA_FOR_USER = gql`
  query NasMediaForUser($userId: Int!) {
    nasMediaForUser(userId: $userId) {
      id
      nasPath
      displayName
      mime
      size
      attachedAt
      attachedByName
    }
  }
`;

export const MY_NAS_MEDIA = gql`
  query MyNasMedia {
    myNasMedia {
      id
      displayName
      mime
      size
      attachedAt
      attachedByName
    }
  }
`;

export const NAS_MEDIA_DOWNLOAD_URL = gql`
  query NasMediaDownloadUrl($nasMediaId: String!) {
    nasMediaDownloadUrl(nasMediaId: $nasMediaId)
  }
`;

export const NAS_FILES_FOR_BROWSING = gql`
  query NasFilesForBrowsing($path: String) {
    nasFilesForBrowsing(path: $path) {
      name
      path
      type
      size
      lastModified
      mime
    }
  }
`;

export const NAS_BROWSE_DOWNLOAD_URL = gql`
  query NasBrowseDownloadUrl($path: String!) {
    nasBrowseDownloadUrl(path: $path)
  }
`;

export const NAS_ASSIGNABLE_USERS = gql`
  query NasAssignableUsers {
    users {
      id
      firstName
      lastName
    }
  }
`;
